import {HOUSE_MARKER_INFO} from '@/map/constants';
import {AreaAnalyticsFilter, BuildingType} from '@/map/enums';

export const getHouseMarkerInfo = (
  type: BuildingType | AreaAnalyticsFilter | string
) => {
  switch (type) {
    case BuildingType.Apartment:
    case BuildingType.Officetel:
    case BuildingType.Villa:
    case AreaAnalyticsFilter.UPCOMMING_APTS:
      return HOUSE_MARKER_INFO[type];
    default:
      return HOUSE_MARKER_INFO[BuildingType.HOUSE];
  }
};
